export enum PaymentSessionStatus {
    cancelled = "c1d2e3f4-a5b6-4789-c012-789012345678",
    expired = "d2e3f4a5-b6c7-4890-d123-890123456789",
    failed = "e3f4a5b6-c7d8-4901-e234-901234567890",
    pending = "f4a5b6c7-d8e9-4012-f345-012345678901",
    succeeded = "a5b6c7d8-e9f0-4123-a456-123456789012",
}

export enum PaymentGatewayCredentialStatus {
    active = "b6c7d8e9-f0a1-4234-b567-345678901234",
    deleted = "c7d8e9f0-a1b2-4345-c678-456789012345",
}

export enum PaymentWebhookProcessingStatus {
    failed = "FAILED",
    processed = "PROCESSED",
    received = "RECEIVED",
    skippedDuplicate = "SKIPPED_DUPLICATE",
}

export enum PaymentReferenceType {
    custom = "CUSTOM",
    invoice = "INVOICE",
    order = "ORDER",
    subscription = "SUBSCRIPTION",
}

export enum PaymentGatewayMode {
    test = "TEST",
    live = "LIVE",
}

export enum PaymentGatewayProvider {
    payu = "PAYU",
    razorpay = "RAZORPAY",
    stripe = "STRIPE",
}
